export const commissionStatemnetsHeadingsData = [
  {
    heading: "$14,357",
    subheading: "Total Commission Earned",
  },
  {
    heading: "$1,321",
    subheading: "Unrealised commission",
  },
];
